import { IAncestorNodeDefinition } from '@glidecms/deliver-core-dev/types/services'

export const getTaxonomyAncestorFromId = (parentId: number): IAncestorNodeDefinition =>
  parentId && parentId > 0
    ? {
        property: 'id',
        value: parentId,
      }
    : null
